import { generateUserDetailsDownloadUrlsApi } from 'api/attachments/fetchers/generateUserDetailsDownloadUrlsApi'
import { createUseFetch } from 'api/common/createUseFetch'
import { ApiQueryKeys } from 'constants/apiQueryKeys'

export const useFetchGenerateUserDetailsDownloadUrlsApi = createUseFetch({
  queryKey: ApiQueryKeys.USER_DETAILS_DOWNLOAD_URLS,
  fetcher: generateUserDetailsDownloadUrlsApi,
})
